import en from './en';
import es from './es';
import ru from './ru';

const messages = {
    "en": en,
    "es": es,
    "ru": ru
}

export default messages;